export default __webpack_public_path__ + "static/media/delievers4.2fa733b8.jpeg";